import styled from 'styled-components'

const FooterImageGridStyles = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export default FooterImageGridStyles;